import type { QueryClient } from '@tanstack/react-query'

import { API_ORIGIN } from '@/constants'
import type { OrganisationOpportunity } from '@/hooks/use-organisation-opportunities'

export async function duplicateEmployerJob(args: {
  token: string | null
  opportunityId: string
  queryClient: QueryClient
}): Promise<OrganisationOpportunity> {
  const { token, opportunityId, queryClient } = args
  if (!token) {
    throw new Error('You need to be signed in to duplicate jobs.')
  }
  const response = await fetch(
    `${API_ORIGIN}/api/opportunities/managed/${encodeURIComponent(opportunityId)}/duplicate/`,
    {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    },
  )
  if (!response.ok) {
    const error = await response.json().catch(() => ({}))
    throw new Error(
      (error as { detail?: string; error?: string }).detail ||
        (error as { detail?: string; error?: string }).error ||
        'Failed to duplicate job',
    )
  }
  const created = (await response.json()) as OrganisationOpportunity
  await queryClient.invalidateQueries({ queryKey: ['organisation-opportunities'] })
  await queryClient.invalidateQueries({ queryKey: ['organisation-opportunity'] })
  await queryClient.invalidateQueries({ queryKey: ['opportunities'] })
  return created
}
